import React from "react";
import { useField } from 'formik';
import "../styles.css";
import ErrorField from "./ErrorField";

const TextInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <>
            <div className="form-group">
                <label htmlFor={props.id || props.name}>{label}</label>
                <input className="text-input form-control" {...field} {...props} />
                <ErrorField meta={meta}></ErrorField>
            </div>
        </>
    );
};

export default TextInput;